import React, { Component, Fragment } from "react";
import FormGroupContainer from "../FormGroup/FormGroupContainer";
import Wrapper from "../FormGroup/Wrapper";
import Label from "../FormGroup/Label";
import ErrorBlock from "../FormGroup/ErrorBlock";
import HelpBlock from "../FormGroup/HelpBlock";
class Checkbox extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleChange = this._handleChange.bind(this);
    }
    render() {
        const { props } = this;
        return (<input {...props.attrs} type="checkbox" className="checkbox-function" checked={props.value} onChange={this._handleChange}/>);
    }
    _handleChange(event) {
        this.props.onChange(event.currentTarget.checked, event);
    }
}
const CheckboxFormGroup = (props) => (<FormGroupContainer {...props}>
		{({ error, id, helpId, errorId, controlState }) => (<Wrapper className={props.className} showError={error != null}>
				<div className="checkbox">
					<Checkbox {...controlState}/>
					<label className="checkbox-style" htmlFor={id}>
						<span className="checkbox-style-box"/>
						<span className="checkbox-style-label">
							<Label label={props.label} required={props.required}/>
							{error != null && (<Fragment>
									{" "}
									<ErrorBlock id={errorId} error={error}/>
								</Fragment>)}
							{props.help != null && (<HelpBlock id={helpId} help={props.help}/>)}
						</span>
					</label>
				</div>
			</Wrapper>)}
	</FormGroupContainer>);
export default CheckboxFormGroup;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/CheckboxFormGroup/CheckboxFormGroup.tsx